import React from 'react';
import Box from '@mui/material/Box';
import { COLORS } from '../../theme/tokens';

/**
 * The GritCargo wordmark: the lowercase, single-word `gritcargo` lockup set in
 * Open Sans Bold, one solid color (brand rule — never split across colors,
 * weights, or lines). In running copy the name is "GritCargo"; the lowercase
 * form is reserved for this lockup. Used on auth screens and wide headers; the
 * narrow nav rail uses <BrandMark/> instead.
 */
interface WordmarkProps {
  /** Solid color of the wordmark (default ink). On navy grounds pass white or Signal Green. */
  color?: string;
  /** Font size in px (default 28). */
  size?: number;
}

const Wordmark: React.FC<WordmarkProps> = ({ color = COLORS.cargoBlack, size = 28 }) => (
  <Box
    component="span"
    aria-label="GritCargo"
    sx={{
      fontFamily: "'Open Sans', sans-serif",
      fontWeight: 700,
      fontSize: `${size}px`,
      lineHeight: 1,
      letterSpacing: '-0.01em',
      color,
      userSelect: 'none',
      whiteSpace: 'nowrap',
    }}
  >
    gritcargo
  </Box>
);

export default Wordmark;
